import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getRequest, handleResponse, patchFormRequests, patchRequest, postFormRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetFaqs(params, key) { // /api/v1/Faq/GetAllFaqs
  const url = "/Faq/GetFaqs"; 
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_Faq", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetFaq(successAction) {
  const url = "/Faq/GetFaq/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostFaq(successAction) { // /api/v1/Faq/CreateFaq
    const url = "/Faq/CreateFaq"; 
    const { user } = useRecoilValue(authAtom)
    return useMutation((payload) => postFormRequest(url, payload, user?.token), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }

  export function useDeleteFaq(successAction) {
    const url = `/Faq/DeleteFaq/`; 
    const axios = useContext(AxiosContext);
    return useMutation((id) => deleteRequest(axios, url+id), {
      onSuccess: (response) => {
        handleResponse(response, () => {
          successAction?.()
          notification.success({
            message: "Success!",
            description: response?.message || "action successful",
          })
        })
      },
      onError: (error) => notification.error({
        message: "Error!",
        description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
      }),
    });
  }



export function usePatchFaq(successAction) {
  const url = `/Faq/EditFaq/`; 
  const axios = useContext(AxiosContext);
  return useMutation((payload) => patchRequest(axios, url+payload?.id, payload), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePatchBlog(successAction) {
  const url = "/Blog/EditBlog/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequests(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}